// extracted by mini-css-extract-plugin
module.exports = {"base":"_1tHPoYCHQR7RoMSF30OoOH","ProjectCardsGroup":"_1_wFT-79N96npYW1yvQBK_"};